// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { SelectItem } from '@advisor-app/components';
import { updateRebalanceConfig } from '@advisor-app/store/slices/parameters';
import { SectionContainer } from '@shared/ui-kit/components';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

interface RebalanceSelectorProps {
  rebalanceType: string;
}

export const RebalanceSelector = ({ rebalanceType }: RebalanceSelectorProps) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const rebalancingTypes = [
    { key: 'withdrawal', name: t('rebalance.withdrawal', { ns: 'rebalance' }) },
    { key: 'deposit', name: t('rebalance.deposit', { ns: 'rebalance' }) },
    {
      key: 'adjustStrategy',
      name: t('rebalance.adjust-strategy', { ns: 'rebalance' }),
    },
  ];

  return (
    <SectionContainer
      title={t('rebalance.select-rebalance-type', { ns: 'rebalance' })}
      variant="h3"
    >
      <div className="boxwrapper !m-0 grid grid-cols-3 gap-5 pt-[18px]">
        {rebalancingTypes.map(({ key, name }) => (
          <SelectItem
            key={key}
            label={name}
            labelId={key}
            groupName="rebalance"
            checkedValidator={rebalanceType}
            handleSelectItem={() => {
              dispatch(updateRebalanceConfig({ type: key }));
            }}
            boxTestId={`rebalance-type-${name}`}
            labelHtmlFor={name}
          />
        ))}
      </div>
    </SectionContainer>
  );
};
